import carousel from './assets/js/carousel.js';
import { multipleCarousel } from './assets/js/multiple-carousel.js';
import timer from './assets/js/timer.js';
import price from './assets/js/price.js';
import video from './assets/js/video.js';
import { openMore } from './assets/js/open-more';
import { applyReverseOpt } from './assets/js/list-utils.js';

const initFcLayouts = () => {
  carousel(window, document);
  multipleCarousel(window, document, 'fc-layout-211');
  multipleCarousel(window, document, 'fc-layout-212');
  multipleCarousel(window, document, 'fc-layout-213');
  multipleCarousel(window, document, 'fc-layout-214');
  multipleCarousel(window, document, 'fc-layout-215');
  timer(window, document);
  price(window, document);
  video(window, document);
  applyReverseOpt(document, ['fc-layout-511']);
  openMore(window, document, ['fc-layout-511', 'fc-layout-513']);
};

export default initFcLayouts;
